import classNames from "classnames";
import React from "react";

import "./tooltip.scss";

interface Props {
  text: string;
  textLength?: "small";
}

export class Tooltip extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  public render() {
    const { text, textLength: textSize } = this.props;

    return (
      <div className={classNames(
        "tl-tooltip",
        { "small-text" : textSize === "small" },
      )} aria-label={text}>
        {this.props.children}
      </div>
    );
  }
}
